import { gql } from "@apollo/client";

export const GET_QUESTIONS = gql`
  query getQuestions {
    questions {
      position
      content
      next_question
      options
      id
      title
      nullable_answer
      nullable_answer_text
      type {
        name
      }
    }
  }
`;
